import { type PimProductV11 } from '@redteclab/api/clients/bully'

export const productAccessorGetSecondLevelCategories = ({
  product,
}: {
  product: PimProductV11
}): string[] => {
  const categories = product.categories ?? []
  const codes = categories
    .map((category) =>
      category.area === 'categories'
        ? category.path_from_root?.[1]?.code
        : undefined,
    )
    .filter((code): code is string => typeof code === 'string')

  // remove duplicates
  return codes.filter((code, index) => codes.indexOf(code) === index)
}
